import { registerQuery } from '@adornis/baseql/metadata/register.js';
import { getRawCollection } from '@adornis/baseql/server/collections.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { MAIL_SYNC_STATUS_ID, MailSyncStatus } from '../db/MailSyncStatus.js';
import { getCurrentUserID } from './currentUserID.js';

/** When the mailbox was last polled, and whether that poll failed or is stuck. */
export const getMailSyncStatus = registerQuery({
  type: () => MailSyncStatus,
  operationName: 'getMailSyncStatus',
  resolve: () => {
    return async (gqlFields: BaseQLSelectionSet<MailSyncStatus>) => {
      if (!getCurrentUserID()) return null;
      const collection = await getRawCollection<MailSyncStatus>(MailSyncStatus._collectionName);
      return (await collection.findOne<MailSyncStatus>({ _id: MAIL_SYNC_STATUS_ID })) ?? null;
    };
  },
  params: [],
});
